import * as React from 'react';

import EntityNameAndAvatar from '../../../EntityNameAndAvatar';

import type { EntityAvatarFragment } from '../../../entity/EntityAvatar/__generated__/EntityAvatar.gql';

interface IEntityPrimaryElementProps {
  /** The merchant, or whatever stands in for one on this row (a card statement's account, say). */
  entity?: EntityAvatarFragment | null;
  fallbackDescription?: string;
  secondaryText?: React.ReactNode;
  /** When set, replaces the entity name as the primary line; the avatar still derives from `entity`. */
  displayNameOverride?: string;
}

const EntityPrimaryElement = ({
  entity,
  fallbackDescription,
  secondaryText,
  displayNameOverride,
}: IEntityPrimaryElementProps) => {
  return (
    <EntityNameAndAvatar
      entity={entity}
      fallbackDescription={fallbackDescription}
      secondaryText={secondaryText}
      displayNameOverride={displayNameOverride}
    />
  );
};

export default EntityPrimaryElement;
